export default __webpack_public_path__ + "static/media/fiari-clean.1f9f0899.svg";